import { render, staticRenderFns } from "./CustomerDraftsTab.htm?vue&type=template&id=0722f7ea&"
import script from "./CustomerDraftsTab.ts?vue&type=script&lang=js&"
export * from "./CustomerDraftsTab.ts?vue&type=script&lang=js&"
import style0 from "./CustomerDraftsTab.scss?vue&type=style&index=0&lang=scss&"
import style1 from "../MyVacanciesTab.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports